/**
 * This is a new server-side type system. From the 27.02.2024
 */
export enum OperationType {
    CLIENT_P2P_BUY = "client_p2p_buy",
    CLIENT_P2P_SELL = "client_p2p_sell",
    CLIENT_INCOME = "client_income",
    CLIENT_TRANSFER = "client_transfer"
}